export default __webpack_public_path__ + "static/media/ic_menu_black_24px.37a8fe94.svg";